import { Component, OnInit } from '@angular/core';
import { Maintenance } from 'src/app/models/maintenance';
import { NgbDateAdapter, NgbTimeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimeNativeAdapter } from 'src/app/adapters/native-time-adapter';
import { MaintenanceService } from 'src/app/services/maintenance.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance-order.service';
import { MaintenanceOrder } from 'src/app/models/maintenance-order';
import { Unity } from 'src/app/models/unity';
import { UnityService } from 'src/app/services/unity.service';
import { MaintenanceLine } from 'src/app/models/maintenance-line';
import { Article } from 'src/app/models/article';
import { ExpenseType } from 'src/app/models/expense-type';
import { ArticleService } from 'src/app/services/article.service';
import { ExpenseService } from 'src/app/services/expense.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { SupplierService } from 'src/app/services/supplier.service';
import { Supplier } from 'src/app/models/supplier';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Warehouse } from 'src/app/models/warehouse';
import { InventoryService } from 'src/app/services/inventory-service';
import { Entry } from 'src/app/models/entry';
import { MaintenanceType } from 'src/app/models/maintenance-type';

@Component({
  selector: 'app-maintenance-create',
  templateUrl: './maintenance-create.component.html',
  styleUrls: ['./maintenance-create.component.css'],
  providers: [
    {provide: NgbDateAdapter, useClass: NativeDateAdapter}, 
    {provide: NgbTimeAdapter, useClass: TimeNativeAdapter}
  ],
})
export class MaintenanceCreateComponent implements OnInit {

  maintenance:Maintenance = new Maintenance();
  line:MaintenanceLine = new MaintenanceLine();
  orders:MaintenanceOrder[] = [];
  unities:Unity[] = [];
  articles:Article[] = [];
  expenses:ExpenseType[] = [];
  warehouses:Warehouse[] = [];
  entries:Entry[] = [];
  loading:boolean = false;
  close:boolean = false;
  total:number = 0;
  maintenanceTypes: MaintenanceType[] = [];

  constructor(private orderServ:MaintenanceOrderService, private mainServ:MaintenanceService, private unityServ:UnityService, private artServ:ArticleService, private expServ:ExpenseService, private modal:NgbModal, private utl:UtilitiesService, private toastr: ToastrManager, private invServ:InventoryService) { }

  ngOnInit() {
    this.loading = true;
    this.unityServ.getUnities().then(unities => {
      this.unities = unities.filter(uni=>uni.unit_type.name != 'Contratistas');
      this.maintenance.unity_id = this.unities[0].id;
      this.loading = false;
    });
    this.artServ.getArticles().then(articles => this.articles = articles.filter(article => article.expense_type.type == 'Mantenimiento'));
    this.expServ.getExpenseTypes().then(expenses => this.expenses = expenses);
    this.invServ.getWarehouses().then(warehouses => this.warehouses = warehouses);
    this.mainServ.getMaintenanceTypes().then(maintenanceTypes => this.maintenanceTypes = maintenanceTypes);
  }

  searchArticles() {
    this.loading = true;
    this.artServ.getArticles().then(articles => {
      this.articles = articles.filter(article => article.expense_type.type == 'Mantenimiento');
      this.loading = false;
    });
  }

  openOrders(win) {
    if (!this.orders.length) {
      this.loading = true;
      this.orderServ.getOrders({
        status: 'Abierta',
        user: null,
      }).then(orders => {
        this.orders = orders;
        this.loading = false;
        this.modal.open(win, { size: 'lg' });
      });
    } else {
      this.modal.open(win, { size: 'lg' });
    }
  }

  selectOrder(ord:MaintenanceOrder) {
    this.maintenance.maintenance_order_id = ord.id;
    this.maintenance.unity_id = ord.unity_id;
  }

  openEntry(win) {
    if (!this.entries.length) {
      this.loadEntries();
    }
    this.modal.open(win, { size: 'lg' });
  }

  selectEntries() {
    let lines:MaintenanceLine[] = [];

    for(let i = 0; i < this.entries.length; i++) {
      let selectedLinesTmp = this.entries[i].lines.filter(line => line.selected);
      for (let j = 0; j < selectedLinesTmp.length; j++) {
        let exp = this.expenses.find(exp => exp.id == this.articles.find(art => art.id == selectedLinesTmp[j].article_id).expense_type_id);

        lines.push({
          article_id: selectedLinesTmp[j].article_id,
          article_name: selectedLinesTmp[j].article_name,
          id: 0,
          iva: selectedLinesTmp[j].iva,
          quantity: selectedLinesTmp[j].quantity,
          entry_line_id: selectedLinesTmp[j].id,
          entry_id: this.entries[i].id,
          status: 'Abierto',
          price: selectedLinesTmp[j].unit_price,
          warehouse_id: selectedLinesTmp[j].warehouse_id,
          warehouse_name: selectedLinesTmp[j].warehouse_name,
          active: true,
          description: selectedLinesTmp[j].description,
          expense_type_id: exp.id,
          expense_type_name: exp.name,
          maintenance_id: 0,
          unity_id: selectedLinesTmp[j].unity_id,
          discount: selectedLinesTmp[j].discount,
          measure_unit: selectedLinesTmp[j].measure_unit,
          warehouse_factor: selectedLinesTmp[j].warehouse_factor,
          warehouse_measure_unit: selectedLinesTmp[j].warehouse_measure_unit,
        });
      }
    }

    this.maintenance.lines = lines;
    this.calcTotal();
  }

  clearOrder() {
    this.maintenance.maintenance_order_id = 0;
    this.maintenance.unity_id = 1;
  }

  openModal(win) {
    this.modal.open(win, { size: 'lg' });
  }

  changeArt() {
    let arti = this.articles.find(art => art.id == this.line.article_id);

    this.line.expense_type_id = arti.expense_type_id;
    this.line.expense_type_name = arti.expense_type.name;
    this.line.article_name = arti.name;
    this.line.measure_unit = arti.measure_unit;
    this.line.warehouse_measure_unit = arti.warehouse_measure_unit;
    this.line.warehouse_factor = arti.warehouse_factor;
  }

  changeExp() {
    let exp = this.expenses.find(e => e.id == this.line.expense_type_id);

    this.line.expense_type_id = exp.id;
    this.line.expense_type_name = exp.name;
  }

  addLine() {
    this.line.warehouse_name = this.warehouses.find(w => w.id == this.line.warehouse_id).name;
    this.maintenance.lines.push(Object.assign({}, this.line));

    this.line = new MaintenanceLine();
    this.calcTotal();
  }

  save() {
    if (!this.maintenance.maintenance_order_id) {
      this.maintenance.maintenance_order_id = null;
    }

    //validate header unity id has same unity id line
    for (let i = 0; i < this.maintenance.lines.length; i++) {
      let ln = this.maintenance.lines[i];
      if (ln.unity_id) {
        if (ln.unity_id != this.maintenance.unity_id) {
          this.toastr.infoToastr("La unidad no coincide con la unidad de las líneas!");
          return;
        }
      }
    }

    this.loading = true;
    this.mainServ.storeMaintenance(this.maintenance, this.close)
      .then(resp => {
        this.toastr.successToastr("Creado correctamente con NO: " + resp.id);
        
        if (this.close) {
          this.orders = this.orders.filter(or => or.id != this.maintenance.maintenance_order_id);
          this.close = false;
        }

        this.maintenance = new Maintenance();
        this.line = new MaintenanceLine();
        this.calcTotal();
        this.loadEntries();
      })
      .catch(e => {
        this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
        this.loading = false;
      });
  }

  removeLine(line:MaintenanceLine) {
    this.maintenance.lines = this.maintenance.lines.filter(l => l != line);
    this.calcTotal();
  }

  calcTotal() {
    this.total = this.maintenance.lines
      .map(ln => ((ln.quantity * ln.price) - ((ln.quantity * ln.price) * (ln.discount / 100))) * (ln.iva*1 + 1))
      .reduce((an, ac) => an + ac, 0);
  }

  loadEntries() {
    this.loading = true;
    this.invServ.getOpenEntries().then(entries => {
      this.entries = entries.filter(e => e.authorized);
      this.loading = false;
    });
  }

}
